<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="product-modal-add" title="Agregar productos" bodyClass="container-md vstack gap-5 py-2" footerClass="container-md py-4">
		<template #body>
			<ul class="list-group list-group-flush rounded-4">
				<template v-if="results.length > 0">
					<template v-for="product in results" :key="product.id">
						<ProductTableAddRow v-for="variant in product.variants" :key="variant.id" :product="product" :variant="variant" @select="select" />
					</template>
				</template>
				<template v-else>
					<li class="list-group-item px-0 py-3 lh-sm" v-if="search.length < 3">
						Buscá productos por nombre o código (ingrese al menos 3 caracteres).
					</li>
					<li class="list-group-item px-0 py-3 lh-sm" v-else-if="loading">
						Buscando productos en la base de datos.
					</li>
					<li class="list-group-item px-0 py-3 lh-sm" v-else>
						No se encontraron productos.
					</li>
				</template>
			</ul>
		</template>
		<template #footer>
			<div class="input-group">
				<input type="text" v-model="search" class="form-control" placeholder="Buscar..." autocomplete="off">
				<span class="input-group-text" v-if="loading">
					<div class="spinner-border spinner-border-sm" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</span>
				<span class="input-group-text" v-else><i class="bi bi-search"></i></span>
			</div>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, onMounted, watch } from 'vue';
	import composableForm from '@/composables/form';
	import ProductRepository from '@/repositories/modules/Product';

	export default {
		emits: ['add'],
		props: {
			company_id: Number
		},
		setup(props, { emit }) {
			const { catchError } = composableForm();
			const loading = ref(false);
			const offcanvas = ref(null);
			const propostal = ref(null);
			const search = ref('');
			const results = ref([]);

			const show = (propostalData) => {
				propostal.value = propostalData;
				offcanvas.value.offcanvas.show();
			}

			onMounted(() => {
				document.getElementById('product-modal-add').addEventListener('shown.bs.offcanvas', () => {
					document.querySelector('#product-modal-add input').focus();
				});

				document.getElementById('product-modal-add').addEventListener('hide.bs.offcanvas', () => {
					empty();
				});
			});

			const getResults = async () => {
				await ProductRepository.index({ search: search.value, company_id: props.company_id }).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'home' });
				});

				loading.value = false;
			}

			const empty = (data) => {
				search.value = '';
				results.value = [];
			}

			const select = (data) => {
				emit('add', data);
				empty();
				document.querySelector('#product-modal-add input').focus();
			}

			const timeout = ref(null);
			watch(search, () => {
				results.value = [];

				if(timeout.value) clearTimeout(timeout.value);
				if(search.value.length >= 3) {
					loading.value = true;
					timeout.value = setTimeout(() => getResults(), 1000);
				}else{
					loading.value = false;
				}
			});

			return { loading, offcanvas, propostal, search, results, show, select };
		}
	}
</script>